import React, {Component} from "react";
import {Table} from "reactstrap";
import "./ProductsTable.css";
import history from "../../history";
import {checkValue, sortBy} from "../../utils";

class ProductsTable extends Component {

    populateTable() {
        return sortBy(this.props.products, "name").map((product, i) => {
            return (
                <tr
                    key={i}
                    onClick={() => {
                        history.push(`/products/${product.uuid}`, {productType: product.type});
                    }}
                >
                    <td className="width-25">{product.name}</td>
                    <td className="width-10 type">{product.type}</td>
                    <td className="width-15">{checkValue(product.serviceCode, "No Code")}</td>
                    <td className="width-40">{checkValue(product.description, "No Description")}</td>
                    <td className="width-10">{(product.isActive) ? "Active" : "Inactive"}</td>
                </tr>
            );
        });
    }

    sort(field) {
        if (this.props.sortingField === field && this.props.sortingOrder === 1) {
            return "sort-up";
        } else if (
            this.props.sortingField === field &&
            this.props.sortingOrder === -1
        ) {
            return "sort-down";
        } else {
            return "sort";
        }
    }


  render() {
    return (
      <div className="products-table">
        <Table hover className="table">
          <thead>
            <tr>
              <th className={`width-25 ${this.props.isInFocus && "highlighted"}`}>Name</th>
              <th className={`width-10 ${this.props.isInFocus && "highlighted"}`}>Type</th>
              <th className={`width-15 ${this.props.isInFocus && "highlighted"}`}>Service Code</th>
              <th className={`width-40 ${this.props.isInFocus && "highlighted"}`}>Description</th>
              <th className="width-10">Status</th>
            </tr>
          </thead>
          <tbody>
          {this.populateTable()}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default ProductsTable;



// WEBPACK FOOTER //
// ./src/products/components/ProductsTable.js